<template>
    <div>
        <div class="page-wrapper home" >

            <!-- <Slider v-bind:slides="slides"/> -->
            <Slider/>
            <div class="navigation-home">
                <div>
                    <router-link to="/richard-mille-watches">Richard Mille</router-link>
                    <router-link to="/new-arrivals">New  Arrivals</router-link>
                    <router-link to="/the-collection">All brands</router-link>
                    <router-link to="/jewellery-catalogue">Jewellery</router-link>
                </div>
            </div>

            <!-- 1st section -->
            <div class="page-grid-fix negative-colors" style="padding-bottom: 85px;" >
                <article class="negative-colors grid-container columns-three-two-rows shadow regular-gap" v-for="(value, key, index) in excerpts.slice(0,1)" v-bind:key="key">
                    <section class="section1">
                        <div class="bg-image" style="height: 650px;" v-bind:style="{ backgroundImage:  'url(' + value.excerpt_image + ')'}">
                        </div>
                    </section>
                    <section class="section2 narrow-column" style="margin: 0 auto;">
                        <div>
                            <h1>{{ value.excerpt_title }}</h1>
                            <div class="p-one" v-html=value.excerpt_description></div>
                            <button type="submit">
                                <router-link :to=value.excerpt_link>{{ value.excerpt_link_title }}</router-link>
                            </button>
                        </div>
                    </section>
                    <section class="section3">
                        <!-- style="padding: 85px 20% 0 20%; font-size: 1.2rem;" -->
                        <div class="p-two" v-html=value.excerpt_description></div>
                    </section>
                </article>
                <div class="space-helper"></div>
                <div style="
                    display: block;
                    position: absolute;
                    height: 85px;
                    width: 50%;
                    border-right: 1px solid black;
                    left: 0;
                "></div>
            </div>
            <!-- 2nd section -->
            
            <div class="page-grid-fix background-img" v-for="(value, key, index) in excerpts.slice(4, 5)" v-bind:key="key"  v-bind:style="{  backgroundImage:  'linear-gradient(rgba(0, 0, 0, 0.527),rgba(0, 0, 0, 0.5)), ' + 'url(' + value.excerpt_image + ')'}">   
                <!-- <div class="overlay-mask"></div>  --> 
                <article class="grid-container columns-one transparent large-gap" v-for="(value, key, index) in excerpts.slice(4, 5)" v-bind:key="key">
                    <section class="section1 transparent">
                        <div>
                            <!-- <h4>{{ value.excerpt_title }}</h4> -->
                            <h4>
                                <img class="rm-logo" src="/images/RM-logo-white.svg" />
                            </h4>
                            <div v-html=value.excerpt_description></div>
                            <button type="submit">
                                <router-link :to=value.excerpt_link>{{ value.excerpt_link_title }}</router-link>
                            </button>
                            <div class="space-helper"></div>
                        </div>
                    </section>
                </article>
            </div>


        </div>

        <!-- Journals -->
        
        <!-- <div class="page-grid-fix">
            <article class="grid-container rows-two regular-gap" style="padding: 39px 0;">
                <section class="section1">
                    <h2>The Journal</h2>
                    <span class="buttons-inline columns-two-mobile" style="float: right;">
                        <button type="submit" class="clean-link" style="padding-right: 0;">
                            <router-link to="/journal">All articles</router-link>
                        </button>
                    </span>
                </section>
            </article>
        </div>
        <article class="journal-index">  
            <section v-for="(journal, index) in journals" :key="journal.id" :class="'section-' + ((index % 10) + 1)">
                <router-link :to="'journal/' + journal.slug">
                <img :src="'/' + journal.index_page_image">
                <div class="excerpt-wrapper">
                    <h3>{{ journal.title }}</h3>
                    <div class="meta ">
                    <span>{{ formatDate(journal.date) }}</span>
                    <strong style="padding: 0 10px;">&#8226;</strong>
                    <span>{{ calculateReadingTime(journal.content) }} MIN READ</span>
                    </div>
                </div>
                <div class="shade"></div>
                </router-link>
            </section>
        </article> -->

            <!-- 3rd section -->
        <div class="page-wrapper home" >
            
            <div class="page-grid-fix bg-fill">
                <article class="negative-colors grid-container columns-three-two-rows large-gap" v-for="(value, key, index) in excerpts.slice(1, 2)" v-bind:key="key">
                    <section class="section1">
                        <div class="bg-image" v-bind:style="{ backgroundImage:  'url(' + value.excerpt_image + ')'}">
                        </div>
                    </section>
                    <section class="section2 padding">
                        <div>
                        <h4>{{ value.excerpt_title }}</h4>
                            <div v-html=value.excerpt_description></div>
                            <button type="submit">
                                <router-link :to=value.excerpt_link>{{ value.excerpt_link_title }}</router-link>
                            </button>
                        </div>
                    </section>
                    <section class="section3" style="padding: 0 0 80px 0;">
                        <article class="grid-container columns-four excerpt tiled">
                            <section><div>
                                <h4>2 Year Warranty</h4>
                                <p>All timepieces are fully serviced, refurbished and are offered with a two-year warranty </p>
                            </div></section>
                            <section><div>
                                <h4>Watch Straps</h4>
                                <p>We are pleased to be able to offer a wide variety of Richard Mille watch straps in store</p>
                            </div></section>
                            <section><div>
                                <h4>Buy Back</h4>
                                <p>Should you wish to sell your timepiece,we will make you an offer on the spot</p>
                            </div></section>
                            <section><div>
                                <h4>Shipping</h4>
                                <p>All shipments are sent via a secure, experienced high value specialist shipper in 1-2 working days</p>
                            </div></section>
                        </article>
                    </section>                       
                </article>
                
            </div>

            <!-- 4th section -->
            

            <div class="page-grid-fix">
	            <article class="grid-container rows-two regular-gap recent-additions">
                    <section class="section1">
				         <h2>Recent additions</h2>
	                        <span class="buttons-inline columns-two-mobile" style="float: right;">
	                            <button type="submit" class="clean-link" style="padding-right: 0;">
	                                <router-link to="/new-arrivals">All watches</router-link>
	                            </button>
                                <!-- <button type="submit" class="clean-link" style="height: 84px;">
	                                <router-link to="/new-arrivals">New arrivals</router-link>
	                            </button> -->
	                        </span>
					    </section>
			            <section class="section2">
                            <div class="grid-view always-three" style="margin-top: 0;">
	                            <div v-for="watch in watches.slice(0, 3)" :key="watch.StockItemId" class="grid-item">
	                                <div class="watch__card-content">
	                                    <router-link v-if="watch.ManufacturerName === 'Richard Mille'" :to="{ name: 'rmwatch', params: { watchSKU: watch.SKU, watchModel: watch.Model.split(' ').join('')  }}">
	                                        <figure>
                                                
	                                            <img class="imageGridSource" :src="imageGridSource(watch)" alt="" :key="watch.SKU">
	                                        <figcaption class="_title">
	                                                <p class="watch-name">{{ watch.Name }}</p>
                                                </figcaption>
	                                        <figcaption>
	                                        <span v-if="watch.StatusName === 'Sold'">Sold</span>
	                                        <!-- <span class="price" v-else-if="watch.Price > 250000">POA</span>
	                                        <span class="price" v-else ><span class="currancy">£</span>{{ watch.Price | formatNumber}}</span><span class="grid-status-divider"> &nbsp; </span> -->
                                            <span v-else class="status">In Stock</span>
                                            <!-- <span v-if="watch.StatusName === null" class="status">In Stock</span>
                                            <span v-else class="status">{{ watch.StatusName }}</span> -->
	                                        </figcaption>
	                                        </figure>
	                                         <!-- <span class="grid-inquiry">Details</span> -->
	                                    </router-link>
	                                    
	                                    <router-link v-else :to="{ name: 'otherwatch', params: { watchSKU: watch.SKU, watchModel: watch.Model.split(' ').join('')  }}">
	                                        <!-- <router-link to="'RM-Watch/' . watch.StockItemId"> -->
	                                        <figure>
	                                           
	                                                <img class="imageGridSource" :src="imageGridSource(watch)" alt="" :key="watch.SKU">
	                                             <figcaption class="_title">
	                                                <p class="watch-name">{{ watch.Name }}</p>                
	                                            </figcaption>
                                                <figcaption>
	                                                 <span v-if="watch.StatusName === 'Sold'">Sold</span>
	                                                <!--  <span class="price" v-else-if="watch.Price > 250000">POA</span>
	                                                 <span class="price" v-else ><span class="currancy">£</span>{{ watch.Price | formatNumber}}</span><span class="grid-status-divider"> &nbsp; </span> -->
                                                     <span v-else class="status">In Stock</span>
                                                     <!-- <span v-if="watch.StatusName === null" class="status">In Stock</span>
                                                     <span v-else class="status">{{ watch.StatusName }}</span> -->
	                                            </figcaption>
	                                    
	                                        </figure>
	                                    </router-link>                          
	                                </div>
	                            </div>           
	                        </div>
				         </section>
	            </article>
                <div class="space-helper"></div>
            </div>

            <!-- 5th section -->

            <div class="space-helper"></div>
            <div class="page-grid-fix">
                <article class="grid-container columns-one large-gap" v-for="(value, key, index) in excerpts.slice(2, 3)" v-bind:key="key">
                        <section class="section1">
                            <div>
                               <h4>{{ value.excerpt_title }}</h4>
                                <div v-html=value.excerpt_description></div>
                                <button type="submit">
                                    <router-link :to=value.excerpt_link>{{ value.excerpt_link_title }}</router-link>
                                </button>
                                <div class="space-helper"></div>
                            </div>
                        </section>
                </article>
			</div>

            <!-- 6th section -->
            <div class="page-grid-fix">
                <article class="grid-container columns-three-two-rows regular-gap" v-for="(value, key, index) in excerpts.slice(3, 4)" v-bind:key="key">
                        <section class="section1">
                            <div class="bg-image" v-bind:style="{ backgroundImage:  'url(' + value.excerpt_image + ')'}">
                            </div>
                        </section>
                        <section class="section2 padding">
                             <div style="max-width: 350px;
                                text-align: left;
                                max-width: 350px;
                                display: table-cell;
                                vertical-align: middle;
                                height: 650px;">
                               <h4>{{ value.excerpt_title }}</h4>
                                <div v-html=value.excerpt_description></div>
                                <button type="submit">
                                    <router-link :to=value.excerpt_link>{{ value.excerpt_link_title }}</router-link>
                                </button>
                            </div>
                        </section>
                        <!-- <section class="section3" style="width: 100vw; display: block;"> -->
                            <section class="section3">
                        </section>
                </article>
            </div>

        
  </div>
</div>
</template>

<script>

// import IndexPage from '../components/IndexPage.vue'
import Slider from '../components/Slider.vue';
    export default {  
      name: 'Home',
      components: {
        //   IndexPage
          Slider
      },
      data () {
        return {
            // slides: [],
            status: null,
            excerpts: [],
            page: [],
            randomVideo: '',
	            // noIntro: {
	            //     noIntro: this.noIntro
	            // },
	            randomImage: '',
	            showRoute: {
	               showRoute : this.$route.name
	            },
			images: {},
			watches: [],
			watch: [],
            journals: [],
        }
      },
     
      
      created() {
          this.getPage();
          this.showRoute = this.$route.name;
          this.allBgVideos;
          this.randomVideo;
          this.randomImage;
           this.$axios.get("/api/journals").then(response => { 
                // this.journals = response.data.slice(0, 5);  
                this.journals = response.data;                
                
            });
      },
      mounted() {
        this.getWatchesOrderes();
        },
      
      methods:{
            getPage(address) {
                var slug = this.$route.name;
                
                 this.$axios.get('/api/home').then(response => {
                    this.page = response.data;
                    this.excerpts = response.data[16];
                    this.allBgImages = this.page[7];
                    this.allBgVideos = this.page[8];
                    var randomNumberImages = Math.floor(Math.random() * (this.allBgImages.length));
                    var randomNumberVideos = Math.floor(Math.random() * (this.allBgVideos.length));
                    this.randomVideo = this.allBgVideos[randomNumberVideos];
                    this.randomImage = this.allBgImages[randomNumberImages];
                    this.$emit("route-data-ready");
                    // if (response.data[9] == '0') {
                    //     this.noIntro = true
                    //     } else {
                    // this.noIntro = false };
                });
                },
                imageGridSource(watch) {
                    return '/watches/gallery/NW-' + watch.SKU + '/grid-image/grid_NW-'  + watch.SKU + '.png';
                },
                formatDate(dateString) {
                const date = new Date(dateString)
                    return date.toLocaleString('default', { month: 'long', year: 'numeric' })
                },
                calculateReadingTime(articleText) {
                    let wordCount = articleText.split(' ').length;
                    let wordsPerMinute = 200;
                    let readingTime = Math.ceil(wordCount / wordsPerMinute);
                    return readingTime;
                },
                getWatchesOrderes(address) {
                     this.$axios.get(address ? address : "/api/watches" ).then(response => {
                    //console.log(response.data.data);
                    this.watches = response.data.data;
             });
           },
             
        },
        // computed: {
        //     isLanding() {
        //        return this.$route.name === 'home'
        //     },
        //     isHome() {
        //         return this.$route.name === 'london'
        //      },
            
        //   }
}
</script>
